import React from 'react';
import ReactTooltip from 'react-tooltip';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import { generateRandomId } from '../../../../../../helpers';
import Program from './card';

class RegistrationProgramBigIcon extends React.Component {

  state = {
    popupverOpen: false,
    removed: false,
    randomId: `ID-${generateRandomId(10)}`
  }

  remove = () => {
    const { program, division } = this.props;
    this.props.fnRemove && this.props.fnRemove(program);
    // TODO: call api
    //this.props.divisionsActions &&
    //this.props.divisionsActions.removeProgram(program, division);
  }

  toggle = () => {
    this.setState({ popoverOpen: !this.state.popoverOpen });
  }

  toggleConfirming = () => {
    this.setState({ confirming: !this.state.confirming });
  }

  render() {
    const { program, index } = this.props;

    // TODO: evaluate if the program still exists in the store. If not, removed = true , and gray it out

    const { popoverOpen, randomId, confirming } = this.state;

    return (
      <i onClick={this.toggle} className={`ml-2 mt-2 fas fa-address-card dark-blue font-60`} data-tip={`${(program || {}).Name}`} data-for={`rule${index}`} id={`${randomId}`}>
        <ReactTooltip effect="solid" place="top" id={`rule${index}`} />
        <Popover placement="top" isOpen={popoverOpen} target={`${randomId}`} toggle={this.toggle}>
          <PopoverBody className="d-flex flex-column justify-content-end">
            <button className="btn btn-link btn-sm blue no-margin no-padding text-right" onClick={this.toggle}>close</button>
            <Program program={program} unmovable={true} />
            <button id={`confirm${index}`} className="btn btn-danger btn-sm btn-block font-8" onClick={this.remove}>Remove this Program ?</button>


            <Popover placement="top" isOpen={confirming} target={`confirm${index}`} toggle={this.toggleConfirming}>
              <PopoverHeader>Are you sure?</PopoverHeader>
              <PopoverBody className="no-padding">
                <button className="btn btn-sm btn-block btn-success no-margin" onClick={this.remove}>Yes, remove it</button>
              </PopoverBody>
            </Popover>
          </PopoverBody>
        </Popover>
      </i>
    );
  }
}

export default RegistrationProgramBigIcon;